import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Select, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { Widget, Button, Table } from '@digital/ui';
import { useRecoilValue } from 'recoil';

import { getDadosGerais, OrdemCompraDadosGerais } from '@app/api/sas/ordemCompra';
import { getAcoesFornecedor, getFornecedoresOc } from '@app/api/sas/sasFornecedor';

import {
  dadosGeraisState,
  ordemCompraIdState,
  stepState,
} from '../atoms';

import ModalAcaoFornecedor from './ModalAcaoFornecedor';

import { IAcaoFornecedor } from '@app/api/sas/sasDocumentoOrdemCompra';
const { Panel } = Collapse;

interface WidgetAcoesFornecedorProps {
  readOnly?: boolean;
}

const WidgetAcoesFornecedor = ({ readOnly = false }: WidgetAcoesFornecedorProps) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const ordemCompra = useRecoilValue(dadosGeraisState);

  const [acoes, setAcoes] = useState<IAcaoFornecedor[]>([]);
  const [updateAcoes, setUpdateAcoes] = useState<boolean>(false);
  const [acaoSelecionada, setAcaoSelecionada] = useState<IAcaoFornecedor | null>(null);

  const [fornecedores, setFornecedores] = useState<{ id: string; nome: string }[]>([]);
  const [fornecedorSelecionado, setFornecedorSelecionado] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!ordemCompraId || !readOnly) return;
    getFornecedoresOc(ordemCompraId).then(r => {
      setFornecedores(r || []);
      if (r && r.length > 0) setFornecedorSelecionado(r[0].id);
    });
  }, [ordemCompraId]);

  useEffect(() => {
    if (!ordemCompraId) return;
    setAcoes([]);
    if (readOnly) {
      if (!fornecedorSelecionado) return;
      getAcoesFornecedor(ordemCompraId, fornecedorSelecionado).then(r => r.acoes && setAcoes(r.acoes));
    } else {
      getAcoesFornecedor(ordemCompraId).then(r => r.acoes && setAcoes(r.acoes));
    }
  }, [ordemCompraId, updateAcoes, fornecedorSelecionado]);



  const atualizaTela = (acaoId: string) => {
    setUpdateAcoes(true);
    //setAcoes(prev => prev.filter(a => a.id !== acaoId));
  };

  const columns = (): ColumnProps<any>[] => [
    { title: 'Ação', dataIndex: 'acao' },
    { title: 'Descrição', dataIndex: 'descricao' },

    {
      title: 'Ação',
      width: '5%',
      render: (_, record: IAcaoFornecedor) => (
        <Tooltip title="Executar ação">
          <Button
            icon="arrows-chevron_right"
            onClick={() => setAcaoSelecionada(record)}
            disabled={record.statusAcao !== 'Pendente'}
          />
        </Tooltip>
      )
    },
    
    {
      title: 'Status',
      render: (_, record: IAcaoFornecedor) => {
        if (!record.statusAcao) return '-';
        const statusAcao = record.statusAcao;
        return <span
          style={{
            color: statusAcao === 'Pendente' ? '#fa8c16' : undefined,
            fontWeight: statusAcao === 'Pendente' ? 500 : undefined,
          }}
        >
          {statusAcao}
        </span>
      },
      dataIndex: 'statusAcao'
    },
    { title: 'Data limite', width: '12%', dataIndex: 'dataLimite' , render: (v) => v ? new Date(v).toLocaleDateString() : "-"},
    { title: 'Data Execução', width: '12%', dataIndex: 'dataExecucao' , render: (v) => v ? new Date(v).toLocaleDateString() : "-"},
  ];

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['documentacao']}
        expandIcon={() => <Icon type="arrows-right_4" />}
      >
        <Panel
          key="documentacao"
          header={`Ações do Fornecedor - OC ${ordemCompra && ordemCompra.numero || ''}`}
        >
          <Widget>
            {readOnly && fornecedores.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <span style={{ marginRight: 8, fontWeight: 500 }}>Fornecedor:</span>
                <Select
                  style={{ width: 350 }}
                  value={fornecedorSelecionado}
                  onChange={(value: string) => setFornecedorSelecionado(value)}
                >
                  {fornecedores.map(f => (
                    <Select.Option key={f.id} value={f.id}>{f.nome}</Select.Option>
                  ))}
                </Select>
              </div>
            )}
            <Table dataSource={acoes} columns={columns()} pagination={false} />
          </Widget>
        </Panel>
      </Collapse>

      {acaoSelecionada && (
        <ModalAcaoFornecedor
          visible
          acao={acaoSelecionada}
          ordemCompraId={ordemCompraId}
          onSuccess={() => atualizaTela(acaoSelecionada.id)}
          onClose={() => setAcaoSelecionada(null)}
          readOnly={readOnly}
        />
      )}
    </>
  );
};

export default WidgetAcoesFornecedor;
